import React, { useEffect, useState } from 'react';
import { 
  IonContent, 
  IonPage, 
  IonProgressBar,
  IonIcon,
} from '@ionic/react';
import { checkmarkCircle} from 'ionicons/icons';
import Axios from 'axios';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import {URLS} from '../assets/URLS';

import { 
  Toolbar, 
  Grid, 
} from '@material-ui/core';

import {Diary} from '../assets/DataStructures'
import useStyles from '../assets/cssClasses';

interface dbProps {
  diary: Diary | null,
  id: string | null,
}

const DiaryIDsAppendForm: React.FC<dbProps> = (props) => {

  const [processing, setProcessing] = useState<boolean>(false);
  const [diary, setDiary] = useState<Diary>(new Diary());

  const classes = useStyles();

  useEffect(()=>{
    if(props.diary){
      setDiary(props.diary)
    }
  },[props.diary])

  const postSurvey = () =>{
    setProcessing(true);
    console.log(diary);
    var formData = new FormData();
    formData.append('varsList', diary.file);
    console.log(formData);

      Axios.post(URLS.append_ids+'/'+props.id, formData).then(function(response){
        setProcessing(false);
        if(response.data.stat === "ERROR"){
            alert(response.data.message);
        }
      },
      function(error){
        setProcessing(false);
         
      })

  } 

  const setFile = (files: any) => {
    diary.file = files[0];
  }


  return (
    <IonPage>
      <IonContent>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <AppBar className={classes.page_title} position="sticky">
            <Toolbar>
              <Typography className={classes.title} variant="h6">Bright MR || DSM - Edit General Diary Info</Typography>
            </Toolbar>
          </AppBar>
        </Grid>
        <Grid item xs={12}>


          <React.Fragment>
              <label htmlFor='ids_file'>UPLOAD FILE with IDS for appendance</label>
              <input type='file' onChange={(e) => setFile(e.target.files)} id='ids_file' className={classes.file_input}></input>
            </React.Fragment>
        </Grid>
      </Grid>


        {processing && 
          <IonProgressBar type="indeterminate"></IonProgressBar>
        }
        <Button color="primary" onClick={()=>postSurvey()} startIcon={<IonIcon icon={checkmarkCircle}/>} className={classes.actionButton}>SAVE</Button>
        </IonContent>
    </IonPage>
  );
};

export {DiaryIDsAppendForm};
